export class BillingDetailRequest {
    first_name: string = '';
    last_name: string = '';
    email: string = '';
    source?: string;
    address: {
        line1: string;
        line2: string;
        city: string;
        state: string;
        postal_code: string;
        country: string;
    } = {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
    };
}